import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { routes } from "./router/index";
import { LayoutRoute } from "./components/layout";
import { ProvideAuth } from "./auth/use-auth";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "css/main.css";

function App() {
  return (
    <ProvideAuth>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ToastContainer
          style={{ width: "90%", "maxWidth": "400px" }}
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          pauseOnFocusLoss
        />
        <Switch>
          {routes.map((props, i) => (
            <LayoutRoute key={i} {...props} />
          ))}
        </Switch>
      </BrowserRouter>
    </ProvideAuth>
  );
}

export default App;
